import React, { useState, useEffect, useRef } from "react";

import fondJeu1 from "assets/puzzles/iserba/roadSafety/fond_jeu_1.svg";
import essuiGlaceCasse from "assets/puzzles/iserba/roadSafety/essui_glace_casse.svg";
import essuiGlaceRepare from "assets/puzzles/iserba/roadSafety/essui_glace_repare.svg";
import retroviseurCasse from "assets/puzzles/iserba/roadSafety/retroviseur_casse.svg";
import retroviseurRepare from "assets/puzzles/iserba/roadSafety/retroviseur_repare.svg";
import roueCasse from "assets/puzzles/iserba/roadSafety/roue_casse.svg";
import roueRepare from "assets/puzzles/iserba/roadSafety/roue_repare.svg";
import cle from "assets/puzzles/iserba/roadSafety/cle.svg";
import TypewriterText from "components/shared/TypeWriterText";

const GRID_SIZE = 6;

const _question = {
	options: [
		{
			value: "essuie-glace",
			isCorrect: true,
			position: [2, 3],
			hint: "Cet essuie-glace me semble défectueux. Je dois en avoir un de rechange dans le coffre. ça y est, c'est réparé!",
			brokenImg: essuiGlaceCasse,
			fixedImg: essuiGlaceRepare,
		},
		{
			value: "roue",
			isCorrect: true,
			position: [4, 3],
			hint: "Mince, les pneus sont sous-gonflés! Je dois avoir un compresseur portable dans le coffre. Ah, c'est bon!",
			brokenImg: roueCasse,
			fixedImg: roueRepare,
		},
		{
			value: "retroviseur",
			isCorrect: true,
			position: [2, 2],
			hint: "Je crois que cette vis est en train de partir. Heureusement que j'ai ce qu'il faut dans la boîte à gants. Et voilà! elle est bien fixée!",
			brokenImg: retroviseurCasse,
			fixedImg: retroviseurRepare,
		},
	],
};

const IserbaGame1ClickPuzzle = ({ question, onAnswer }) => {
	const [grid, setGrid] = useState(
		Array(GRID_SIZE)
			.fill(null)
			.map(() => Array(GRID_SIZE).fill(null))
	);
	const gridRef = useRef(null);
	const [gridSize, setGridSize] = useState(0);
	const [hint, setHint] = useState(null);

	useEffect(() => {
		const updateSize = () => {
			if (gridRef.current) {
				const size = Math.min(window.innerWidth, window.innerHeight - 300);
				setGridSize(size);
			}
		};
		updateSize();
		window.addEventListener("resize", updateSize);
		return () => window.removeEventListener("resize", updateSize);
	}, []);

	useEffect(() => {
		setGrid((prevGrid) => {
			const newGrid = prevGrid.map((row) => [...row]);
			_question.options.forEach(({ position, brokenImg, fixedImg }) => {
				const [x, y] = position;
				newGrid[x][y] = { fixed: false, brokenImg, fixedImg };
			});
			return newGrid;
		});
	}, []);

	const toggleCell = (x, y) => {
		_question.options.forEach((option) => {
			if (
				option.position[0] === x &&
				option.position[1] === y &&
				!grid[x][y]?.fixed
			) {
				setHint({
					text: option.hint,
					onClickFinish: () => {
						setHint(null);
					},
				});
			}
		});
		setGrid((prevGrid) => {
			const newGrid = prevGrid.map((row) => [...row]);
			if (newGrid[x][y]) {
				newGrid[x][y] = { ...newGrid[x][y], fixed: true };
			}
			return newGrid;
		});
	};

	const submitAnswer = () => {
		const errors = [];

		_question.options.forEach(({ position, value }) => {
			const [x, y] = position;

			if (!grid[x][y]?.fixed) {
				errors.push(value);
			}
		});

		const allCorrect = errors.length === 0;

		onAnswer({
			scene_1_correct: allCorrect,
			scene_1_errors: errors,
		});
	};

	return (
		<div className="relative flex flex-col items-start non-selectable">
			<div
				ref={gridRef}
				className={`relative grid grid-cols-${GRID_SIZE} grid-rows-${GRID_SIZE} gap-0 m-auto w-full aspect-square border-black border-8 shadow-[5px_5px_0px_rgba(0,0,0,1)] bg-black`}
				style={{
					width: gridSize,
					height: gridSize,
					backgroundImage: fondJeu1 ? `url(${fondJeu1})` : "none",
					backgroundSize: "cover",
				}}
			>
				{_question.options.map(({ brokenImg, fixedImg, position }, index) => (
					<img
						key={index}
						src={grid[position[0]][position[1]]?.fixed ? fixedImg : brokenImg}
						alt="Grid Element"
						className="absolute top-0 left-0 w-full h-full object-contain pointer-events-none"
					/>
				))}

				{grid.map((row, x) =>
					row.map((cell, y) => (
						<div
							key={`${x}-${y}`}
							onClick={() => toggleCell(x, y)}
							className="w-full h-full flex items-center justify-center  aspect-square cursor-pointer transition-all bg-transparent"
						/>
					))
				)}
				{hint && (
					<div
						className={`absolute top-[0%] right-4 left-4 text-sm py-2 px-4 shadow-md mb-4 bg-white rounded-3xl`}
					>
						<TypewriterText
							text={hint.text}
							onClickFinish={hint.onClickFinish}
						/>
					</div>
				)}
			</div>
			<div className="mt-4 h-24 px-4 mb-8 flex w-full justify-end items-center gap-0">
				<img src={cle} alt="cle" className="w-12 h-12 inline-block mr-2" />
				<button
					onClick={submitAnswer}
					className="mt-2 rounded-full px-4 py-2 border-black text-white bg-[#fbb554] shadow-[6px_6px_0px_rgba(0,0,0,0.7)] hover:bg-[#ffa256] disabled:bg-slate-300"
				>
					Continuer
				</button>
			</div>
		</div>
	);
};

export default IserbaGame1ClickPuzzle;
